export const GET_STORAGE_HISTORY = 'GET_STORAGE_HISTORY'
export const GET_STORAGE_HISTORY_SUCCESS = 'GET_STORAGE_HISTORY_SUCCESS'
export const GET_STORAGE_HISTORY_FAILURE = 'GET_STORAGE_HISTORY_FAILURE'

export const GET_ASSETS_LIST = 'GET_ASSETS_LIST'
export const GET_ASSETS_LIST_SUCCESS = 'GET_ASSETS_LIST_SUCCESS'
export const GET_ASSETS_LIST_FAILURE = 'GET_ASSETS_LIST_FAILURE'

export const GET_FOLDER_SPACE = 'GET_FOLDER_SPACE'
export const GET_FOLDER_SPACE_SUCCESS = 'GET_FOLDER_SPACE_SUCCESS'
export const GET_FOLDER_SPACE_FAILURE = 'GET_FOLDER_SPACE_FAILURE'